<div class="w-full max-w-4xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white">
      Wyślij powiadomienie
    </h1>
    <p class="text-gray-600 dark:text-gray-400 mt-1">
      Wyślij powiadomienie push do wszystkich użytkowników
    </p>
  </div>

  <!-- Form -->
  <div class="bg-card rounded-2xl shadow-lg overflow-hidden">

    <!-- Form content -->
    <div class="p-6">
      <form [formGroup]="form">

        <!-- Title field -->
        <mat-form-field appearance="outline" class="w-full mb-4">
          <mat-label>Tytuł powiadomienia</mat-label>
          <input
            type="text"
            matInput
            formControlName="title"
            placeholder="Wprowadź tytuł powiadomienia">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:heading'" class="text-gray-500"></mat-icon>
          <mat-error *ngIf="form.controls.title.hasError('required')">
            Tytuł jest wymagany
          </mat-error>
          <mat-hint>Maks. 200 znaków</mat-hint>
        </mat-form-field>

        <!-- Message field -->
        <mat-form-field appearance="outline" class="w-full mb-4">
          <mat-label>Treść powiadomienia</mat-label>
          <textarea
            matInput
            formControlName="message"
            placeholder="Wprowadź treść powiadomienia"
            rows="4"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10"></textarea>
          <mat-icon matPrefix [svgIcon]="'tabler_outline:message'" class="text-gray-500"></mat-icon>
          <mat-error *ngIf="form.controls.message.hasError('required')">
            Treść jest wymagana
          </mat-error>
          <mat-hint>Maks. 1000 znaków</mat-hint>
        </mat-form-field>

        <!-- Save to notifications toggle -->
        <div class="mb-6">
          <div class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
                <mat-icon
                  class="text-primary-600 dark:text-primary-400"
                  [svgIcon]="'tabler_outline:bell'">
                </mat-icon>
              </div>
              <div>
                <p class="font-semibold text-gray-900 dark:text-white">Zapisz w powiadomieniach</p>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  {{ form.controls.saveToNotifications.value
                    ? 'Powiadomienie zostanie zapisane w dzwoneczku i wysłane jako push'
                    : 'Powiadomienie zostanie wysłane tylko jako push (bez zapisu w dzwoneczku)' }}
                </p>
              </div>
            </div>
            <mat-slide-toggle
              formControlName="saveToNotifications"
              color="primary"
              class="ml-4">
            </mat-slide-toggle>
          </div>
        </div>

        <!-- Channels: browsers + mobile -->
        <div class="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                <mat-icon
                  class="text-blue-600 dark:text-blue-400"
                  [svgIcon]="'tabler_outline:browser'">
                </mat-icon>
              </div>
              <div>
                <p class="font-semibold text-gray-900 dark:text-white">Wyślij na przeglądarki</p>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  Web Push do użytkowników z włączonymi powiadomieniami
                </p>
              </div>
            </div>
            <mat-slide-toggle
              formControlName="sendToBrowsers"
              color="primary"
              class="ml-4">
            </mat-slide-toggle>
          </div>

          <div class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                <mat-icon
                  class="text-green-600 dark:text-green-400"
                  [svgIcon]="'tabler_outline:device-mobile'">
                </mat-icon>
              </div>
              <div>
                <p class="font-semibold text-gray-900 dark:text-white">Wyślij na telefony</p>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  Push (FCM/APNS) do aplikacji mobilnej iOS/Android
                </p>
              </div>
            </div>
            <mat-slide-toggle
              formControlName="sendToMobile"
              color="primary"
              class="ml-4">
            </mat-slide-toggle>
          </div>
        </div>

      </form>
    </div>

    <!-- Test push section -->
    <div class="px-6 pb-6">
      <div class="p-4 border border-dashed border-amber-300 dark:border-amber-700 bg-amber-50/50 dark:bg-amber-900/10 rounded-xl">
        <div class="flex items-center gap-3 mb-3">
          <div class="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
            <mat-icon
              class="text-amber-600 dark:text-amber-400"
              [svgIcon]="'tabler_outline:bell-ringing'">
            </mat-icon>
          </div>
          <div>
            <p class="font-semibold text-gray-900 dark:text-white">Wyślij testowe push do użytkownika</p>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Znajduje usera po emailu, sprawdza jego urządzenia (przeglądarki + telefony) i wysyła powiadomienie. Wyświetli ile dotarło.
            </p>
          </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-3">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Email użytkownika</mat-label>
            <input
              type="email"
              matInput
              [formControl]="testEmailControl"
              placeholder="np. user@example.com">
            <mat-icon matPrefix [svgIcon]="'tabler_outline:user'" class="text-gray-500"></mat-icon>
            <mat-error *ngIf="testEmailControl.hasError('required')">
              Email jest wymagany
            </mat-error>
            <mat-error *ngIf="testEmailControl.hasError('email')">
              Nieprawidłowy format email
            </mat-error>
          </mat-form-field>

          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="sendTestEmail()"
            [disabled]="isSendingTest || isSending"
            class="!rounded-lg sm:!h-14 !min-w-[180px]">
            <mat-spinner *ngIf="isSendingTest" diameter="20" class="mr-2"></mat-spinner>
            <mat-icon *ngIf="!isSendingTest" [svgIcon]="'tabler_outline:send'" class="mr-2"></mat-icon>
            {{ isSendingTest ? 'Wysyłanie...' : 'Wyślij test' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="p-6 bg-gray-50 dark:bg-gray-800 border-t dark:border-gray-700 flex items-center justify-end gap-4">
      <button
        mat-raised-button
        color="primary"
        (click)="send()"
        [disabled]="isSending"
        class="!rounded-lg">
        <mat-spinner *ngIf="isSending" diameter="20" class="mr-2"></mat-spinner>
        <mat-icon *ngIf="!isSending" [svgIcon]="'tabler_outline:send'" class="mr-2"></mat-icon>
        {{ isSending ? 'Wysyłanie...' : 'Wyślij powiadomienie' }}
      </button>
    </div>

  </div>

  <!-- Result card -->
  <div *ngIf="lastResult" class="mt-6 bg-card rounded-2xl shadow-lg overflow-hidden">
    <div class="p-6">
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        <mat-icon [svgIcon]="'tabler_outline:check'" class="text-green-500 mr-2 align-middle"></mat-icon>
        Wynik wysyłki
      </h2>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div class="p-3 bg-gray-50 dark:bg-gray-800 rounded-xl text-center">
          <div class="text-2xl font-bold text-gray-900 dark:text-white">{{ lastResult.totalUsers }}</div>
          <div class="text-sm text-gray-500">Użytkowników</div>
        </div>
        <div class="p-3 bg-gray-50 dark:bg-gray-800 rounded-xl text-center">
          <div class="text-2xl font-bold text-green-600">{{ lastResult.pushSent }}</div>
          <div class="text-sm text-gray-500">Push przeglądarka</div>
        </div>
        <div class="p-3 bg-gray-50 dark:bg-gray-800 rounded-xl text-center">
          <div class="text-2xl font-bold text-emerald-600">{{ lastResult.mobileSent || 0 }}</div>
          <div class="text-sm text-gray-500">Push mobile</div>
        </div>
        <div class="p-3 bg-gray-50 dark:bg-gray-800 rounded-xl text-center">
          <div class="text-2xl font-bold" [class.text-red-600]="(lastResult.pushFailed + (lastResult.mobileFailed || 0)) > 0" [class.text-gray-400]="(lastResult.pushFailed + (lastResult.mobileFailed || 0)) === 0">{{ lastResult.pushFailed + (lastResult.mobileFailed || 0) }}</div>
          <div class="text-sm text-gray-500">Push nieudane</div>
        </div>
        <div *ngIf="lastResult.saveToNotifications" class="p-3 bg-gray-50 dark:bg-gray-800 rounded-xl text-center">
          <div class="text-2xl font-bold text-blue-600">{{ lastResult.bellSaved }}</div>
          <div class="text-sm text-gray-500">Zapisane w dzwoneczku</div>
        </div>
      </div>
    </div>
  </div>

</div>
